import { useReorderAlertStore } from "../../store/reorderAlertStore";

/**
 * Notification badge showing active alert count (Story 6.3).
 * Red when high_priority > 0, yellow when medium/low only.
 * Hidden when total_active === 0.
 */
export function AlertBadge() {
  const alertCount = useReorderAlertStore((s) => s.alertCount);
  if (!alertCount || alertCount.total_active === 0) return null;

  const count = alertCount.total_active;
  const isRed = alertCount.high_priority > 0;
  const bg = isRed
    ? "bg-red-500 text-white dark:bg-red-600"
    : "bg-amber-500 text-white dark:bg-amber-600";

  return (
    <span
      className={`inline-flex min-w-[1.25rem] h-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold ${bg}`}
      aria-label={`${count} active alert${count !== 1 ? "s" : ""}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
